/**
 * Mention « Business » d'une offre d'affaire, qui cède la place à sa marge.
 *
 * Deux informations pour une seule ligne : la carte produit n'a pas la place de
 * les afficher côte à côte, et la marge seule ne dirait pas de quel type
 * d'offre il s'agit. Elles défilent donc, « Business » en premier — c'est le
 * repère, la marge n'est que l'argument.
 *
 * Même mécanique que les avantages du bloc transport de l'accueil : glissement
 * vertical en CSS pur, premier élément dupliqué en fin de liste pour reboucler
 * sans à-coup. Pas de minuteur JavaScript — vingt cartes en grille en
 * feraient vingt.
 *
 * Sans marge calculable (prix marché absent, offre à perte), la mention reste
 * fixe : mieux vaut ne rien promettre qu'annoncer un pourcentage faux.
 */
import { BriefcaseBusiness, ChartNoAxesCombined } from "lucide-react";

const LINE = "flex h-4 items-center gap-1 leading-4 whitespace-nowrap";

const BusinessLabel = () => (
  <span className={`${LINE} text-orange-500`}>
    <BriefcaseBusiness className="w-3 h-3 shrink-0" />
    Business
  </span>
);

const MarginLabel = ({ percent }) => (
  <span className={`${LINE} text-green-600`}>
    <ChartNoAxesCombined className="w-3 h-3 shrink-0" />
    {percent}% de marge
  </span>
);

const BusinessTag = ({ marginPercent = null, className = "" }) => {
  const hasMargin = Number.isFinite(marginPercent) && marginPercent > 0;

  if (!hasMargin) {
    return (
      <span className={`inline-flex font-semibold ${className}`}>
        <BusinessLabel />
      </span>
    );
  }

  return (
    <span className={`inline-block h-4 overflow-hidden font-semibold ${className}`}>
      <span className="flex flex-col animate-adv-rotate-fast">
        <BusinessLabel />
        <MarginLabel percent={marginPercent} />
        <BusinessLabel />
      </span>
    </span>
  );
};

export default BusinessTag;
